// extracted by mini-css-extract-plugin
export default {"name":"qpHRAenw7Q0iunQxUA5B0","truncatedText":"_556RR-xDe8XViaFrJgOBC","categoryLink":"_3zEP-FKYbxFhrSylbQjq2z","image":"_3yYXKc51mD6dYa00gCXl4Z"};